import type NumberFormat from 'react-number-format';
import isRecord from 'utils/isRecord';
import requireValue from 'utils/requireValue';

/** `parseFloat(value).toFixed(3) * 1`: the value rounded to 3 decimals (NaN if not a number). */
export const toRoundedValue = (value: unknown) => Number(parseFloat(String(value)).toFixed(3));

/** `Number.isFinite(value.user_input) ? value.user_input : value.calculated_value` */
export function userOrCalculatedValue(value: unknown): unknown {
  const presentValue = requireValue(value, 'user_input');
  const field: Record<string, unknown> = isRecord(presentValue) ? presentValue : {};
  return Number.isFinite(field.user_input) ? field.user_input : field.calculated_value;
}

/** `inputRef.current.state.numAsString`: the unformatted number typed in the input. */
export function numAsStringOf(input: NumberFormat | null): unknown {
  // The state of react-number-format is typed `any`.
  const inputState: unknown = requireValue(input, 'state').state;
  const presentState = requireValue(inputState, 'numAsString');
  return isRecord(presentState) ? presentState.numAsString : undefined;
}
